import React from 'react'
import {useFormContext} from 'react-hook-form'

import {BusinessOfferSlotDesktop as BusinessOfferSlot} from '../../../BusinessOfferSlot'
import {ChangePaymentCardModal} from '../ChangePaymentCardModal/index@desktop'
import {PaymentCardButton} from '../PaymentCardButton/index@desktop'
import {usePaymentCard} from './hooks/usePaymentCard'
import type {PaymentCardProps} from './types'

export function PaymentCard(props: PaymentCardProps): React.ReactElement {
  const {baseProps, changePaymentCardModalProps} = usePaymentCard(props)
  const {watch} = useFormContext()
  const isBusiness = watch('is_business')

  return (
    <>
      <PaymentCardButton {...baseProps} />
      {isBusiness && <BusinessOfferSlot />}
      {changePaymentCardModalProps?.opened && <ChangePaymentCardModal {...changePaymentCardModalProps} />}
    </>
  )
}
